const desc = `<html>
  <head>
    <meta content="text/html; charset=UTF-8" http-equiv="content-type" />
  </head>
  <body class="c3 doc-content">
    <p class="c4" dir="rtl">
      <span class="c1 bold">"בכפר ובעבודה" בוסתנאי</span
      ><span class="c2"> כז אב תרצ"ד  [1934 08 08</span>
    </p>
  </body>
</html>`;

export default desc;
